//#region import libraries
// react
import React, { useEffect, useState } from "react";

// service
import * as BookingService from "_services/booking-service";

// custom components
import { TableCount } from "_organisms";

// bootstrap
import { Row, Col, Button } from "react-bootstrap";


// redux
import { useSelector, useDispatch } from "react-redux";
import { selectDateToISO, selectOrder } from "_redux/slices/prm-bookings/calendar";
import { selectBookingTableType } from "_redux/slices/prm-bookings/bookings-table";
import {
  selectDepartureSkip,
  IncreaseDepartureSkip,
  DecreaseDepartureSkip,
  getDepartures,
  selectDepartureCount,
} from "_redux/slices/prm-bookings/departures";
import { selectArrivalsSkip, IncreaseArrivalSkip, DecreaseArrivalSkip, getArrivals, selectArrivalsCount, } from "_redux/slices/prm-bookings/arrivals";
import { selectUserDb } from "_redux/slices/main-screen/user";
import { selectAirlineSelectedAirport } from "_redux/slices/prm-bookings/bookings";
import { selectIata } from "_redux/slices/main-screen/user";
import { selectAnalyticsTypeSelector, selectArrivalsForecastList, selectDepartureForecastList, selectDeparturesArrivalsCountByHour, } from "_redux/slices/prm-bookings/bookings-count";
import { getAirportBase64Logo, selectAirportBase64Logo } from "_redux/slices/analytics/reviews";

// icons
import { GoChevronLeft, GoChevronRight } from "react-icons/go";

// utils
import { Colors } from "_styles";
import { makeExcel } from "_utils/makeExcel";

//#endregion

const PaginationClicker = (props) => {
  //#region redux
  const dispatch = useDispatch();
  const dbUser = useSelector(selectUserDb); // user
  const iata = useSelector(selectIata); // iata
  const date = useSelector(selectDateToISO); // date of bookings
  const type = useSelector(selectBookingTableType); // departures or arrivals
  const departureSkip = useSelector(selectDepartureSkip); // departure skip
  const arrivalSkip = useSelector(selectArrivalsSkip); // arrival skip
  const airport = useSelector(selectAirlineSelectedAirport); // what is this?
  const order = useSelector(selectOrder); // order filter ???
  const departuresCount = useSelector(selectDepartureCount); // total number of departures
  const arrivalsCount = useSelector(selectArrivalsCount); // total number of arrivals
  const analyticsTypeSelector = useSelector(selectAnalyticsTypeSelector); // 'source' (app/sita/portal) or 'none' (all bookings)
  const arrivalsForecast = useSelector(selectArrivalsForecastList);
  const departuresForecast = useSelector(selectDepartureForecastList);
  const splitData = useSelector(selectDeparturesArrivalsCountByHour);
  const airportBase64Logo = useSelector(selectAirportBase64Logo)

  // #endregion

  const [reportIsLoading, setReportIsLoading] = useState(false)
  const [connectReportIsLoading, setConnectReportIsLoading] = useState(false)
  const [dailyReportIsLoading, setDailyReportIsLoading] = useState(false)

  // controler
  const controller = new AbortController();

  useEffect(() => {
    if (iata) dispatch(getAirportBase64Logo(iata))
  }, []);

  // filters
  const limit = 100;

  // show more handler
  const showMore = () => {
    if (type == "Departures") {
      // get departures and increase count
      dispatch(
        getDepartures(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: departureSkip + limit,
            search: "",
            carrierCode:
              dbUser.details.type != "AIRLINE" ? "" : dbUser.details.authority,
            order: order,
          },
          controller.signal
        )
      );
      dispatch(IncreaseDepartureSkip(limit));
    } else {
      // get arrivals and increase count
      dispatch(
        getArrivals(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: arrivalSkip + limit,
            search: "",
            carrierCode:
              dbUser.details.type != "AIRLINE" ? "" : dbUser.details.authority,
            order: order,
          },
          controller.signal
        )
      );
      dispatch(IncreaseArrivalSkip(limit));
    }
  };

  // show less handler
  const showLess = () => {
    if (type == "Departures") {
      dispatch(
        getDepartures(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: departureSkip - limit,
            search: "",
            carrierCode:
              dbUser.details.type != "AIRLINE" ? "" : dbUser.details.authority,
            order: order,
          },
          controller.signal
        )
      );
      dispatch(DecreaseDepartureSkip(limit));
    } else {
      dispatch(
        getArrivals(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: limit,
            skip: arrivalSkip - limit,
            search: "",
            carrierCode:
              dbUser.details.type != "AIRLINE" ? "" : dbUser.details.authority,
            order: order,
          },
          controller.signal
        )
      );
      dispatch(DecreaseArrivalSkip(limit));
    }
  };
  //#region functions for report
  // generate report as xlsx file
  async function handleExcel(csvData, fileName) {
    const rows = csvData
      .trim()
      .split("\n")
      .map((line) => line.split(","));
    let data = {};
    const headers = rows[0]
    data.fileName = fileName;
    data.workSheetName = [fileName];
    data.columnTitles = [headers];
    data.columnWidth = [headers?.map((row) => row.length + 10)];
    data.rows = [rows.slice(1)];
    await makeExcel(data, iata, airportBase64Logo);
  }
  // download csv
  async function downloadCSVfile() {
    setReportIsLoading(true);
    try {
      let csv = "";

      if (type == "Departures") {
        csv = await BookingService.getDepartures(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 10000,
            skip: 0,
            search: "",
            carrierCode:
              dbUser.details.type != "AIRLINE" ? "" : dbUser.details.authority,
            order: order,
            source: analyticsTypeSelector,
            csv: true,
          },
          controller.signal
        );
      }
      if (type == "Arrivals") {
        csv = await BookingService.getArrivals(
          {
            iata: dbUser.details.type != "AIRLINE" ? iata : airport,
            start: date,
            end: date,
            limit: 10000,
            skip: 0,
            search: "",
            carrierCode:
              dbUser.details.type != "AIRLINE" ? "" : dbUser.details.authority,
            order: order,
            source: analyticsTypeSelector,
            csv: true,
          },
          controller.signal
        );
      }
      await handleExcel(csv, `booking_list_export_${type}_${date}.csv`)
    } catch (e) {
      console.log(e);
    }
    setReportIsLoading(false);

  }

  async function downloadPRMBookings() {
    console.log("called");
    setConnectReportIsLoading(true)
    try {
      let csv = "";

      csv = await BookingService.getPRMConnectBookings(
        {
          iata: dbUser.details.type != "AIRLINE" ? iata : airport,
          start: date,
          end: date,
          limit: 10000,
          skip: 0,
          search: "",
          carrierCode:
            dbUser.details.type != "AIRLINE" ? "" : dbUser.details.authority,
          order: order,
          source: analyticsTypeSelector,
          csv: true,
        },
        controller.signal
      );
      await handleExcel(csv, `prm-connect-bookings_${date}`)
      // const element = document.createElement("a");
      // const file = new Blob([csv], {
      //   type: "text/plain",
      // });

      // element.href = URL.createObjectURL(file);
      // element.download = `prm-connect-bookings_${date}.csv`;
      // document.body.appendChild(element);
      // element.click();
    } catch (e) {
      console.log(e);
    }
    setConnectReportIsLoading(false)

  }



  const handleDailyBookingsReport = async () => {
    /* fixed 24 hours for header */
    const hoursList = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23,
    ];

    // categories in left column
    const categories = [
      "Departures",
      "Arrivals",
      "Totals",
      "DepFlights",
      "ArrFlights",
      "TotalFlights",
      "AgentsOnDuty",
    ];

    let departureFlights = [];
    let departureFlightDictionary = {};

    let arrivalFlights = [];
    let arrivalFlightDictionary = {};

    let totalFlights = [];

    arrivalsForecast.forEach((forecastedFlight) => {
      let flight = forecastedFlight.flight;
      let time = forecastedFlight.formattedTime;
      let hour = new Date(time).getHours();
      if (!arrivalFlightDictionary[hour]) {
        arrivalFlightDictionary[hour] = 1;
      } else {
        arrivalFlightDictionary[hour] += 1;
      }
    });

    departuresForecast.forEach((forecastedFlight) => {
      let flight = forecastedFlight.flight;
      let time = forecastedFlight.formattedTime;
      let hour = new Date(time).getHours();
      if (!departureFlightDictionary[hour]) {
        departureFlightDictionary[hour] = 1;
      } else {
        departureFlightDictionary[hour] += 1;
      }
    });

    hoursList.forEach((hour) => {
      // add departure count
      if (departureFlightDictionary[hour]) {
        departureFlights.push(departureFlightDictionary[hour]);
      } else {
        departureFlights.push("");
      }

      // add arrival count
      if (arrivalFlightDictionary[hour]) {
        arrivalFlights.push(arrivalFlightDictionary[hour]);
      } else {
        arrivalFlights.push("");
      }

      // add total count
      if (departureFlightDictionary[hour] && arrivalFlightDictionary[hour]) {
        totalFlights.push(
          departureFlightDictionary[hour] + arrivalFlightDictionary[hour]
        );
      } else if (departureFlightDictionary[hour]) {
        totalFlights.push(departureFlightDictionary[hour]);
      } else if (arrivalFlightDictionary[hour]) {
        totalFlights.push(arrivalFlightDictionary[hour]);
      } else {
        totalFlights.push("");
      }
    });

    let hours = [];
    let departures = [];
    let arrivals = [];
    let totals = [];
    splitData.forEach((forecast) => {
      let hour = forecast.name;
      let arrivalCount = forecast["Arrivals"];
      let departureCount = forecast["Departures"];

      hours.push(hour);
      departures.push(departureCount > 0 ? departureCount : "");
      arrivals.push(arrivalCount > 0 ? arrivalCount : "");
      totals.push(
        departureCount + arrivalCount > 0 ? departureCount + arrivalCount : ""
      );
    });

    // prepare data
    const data = {
      Departures: departures,
      Arrivals: arrivals,
      Totals: totals,
      DepFlights: departureFlights,
      ArrFlights: arrivalFlights,
      TotalFlights: totalFlights,
      AgentsOnDuty: [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    };

    // converts data to CSV
    function convertToCSV(data) {
      const headers = ["Hours", ...hours, "Total"];
      let rows = categories.map((category) =>
        [
          category,
          ...data[category],
          data[category].reduce((a, b) => (b ? a + b : a), 0),
        ].join(",")
      );

      // Find the indices of "Totals" and "TotalFlights"
      const totalsIndex = categories.indexOf("Totals");
      const totalFlightsIndex = categories.indexOf("TotalFlights");

      // Create an empty row with the correct number of columns
      const emptyRow = Array(headers.length).fill("").join(",");

      // Insert an empty row after the "Totals" row
      if (totalsIndex >= 0) {
        rows.splice(totalsIndex + 1, 0, emptyRow);
      }

      // Adjust the index for "TotalFlights" if necessary
      const adjustedTotalFlightsIndex =
        totalFlightsIndex > totalsIndex
          ? totalFlightsIndex + 1
          : totalFlightsIndex;

      // Insert an empty row after the "TotalFlights" row
      if (adjustedTotalFlightsIndex >= 0) {
        rows.splice(adjustedTotalFlightsIndex + 1, 0, emptyRow);
      }

      return [headers.join(","), ...rows].join("\n");
    }
    // downloads CSV file
    // function downloadCSV(csvString, filename = "data.csv") {
    //   const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    //   const link = document.createElement("a");
    //   link.href = URL.createObjectURL(blob);
    //   link.setAttribute("download", filename);
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // }

    const csvString = convertToCSV(data);
    // downloadCSV(csvString, "daily_bookings_.csv");
    await handleExcel(csvString, "daily_bookings")
    setDailyReportIsLoading(false)
  };
  //#endregion

  return (
    <Row className="mt-3">
      <Col xs={9}>
        {/* export csv button */}
        <Button
          variant={"outline-secondary"}
          onClick={downloadCSVfile}
          disabled={reportIsLoading}
          loading={reportIsLoading}
          style={{ width: 180, marginLeft: 15 }}
        >
          Export Bookings
        </Button>
        <Button
          variant={"outline-secondary"}
          onClick={downloadPRMBookings}
          disabled={connectReportIsLoading}
          loading={connectReportIsLoading}
          style={{ marginLeft: 15 }}
        >
          Export Connect Bookings
        </Button>

        <Button
          variant={"outline-secondary"}
          onClick={() => {
            setDailyReportIsLoading(true)
            handleDailyBookingsReport();
          }}
          disabled={dailyReportIsLoading}
          loading={dailyReportIsLoading}
          style={{ marginLeft: 15 }}
        >
          Export Daily Bookings
        </Button>
      </Col>
      <Col className="mt-3">
        <Row style={{ display: "flex" }}>
          {/* count */}
          <Col xs={7}>
            <TableCount />
          </Col>

          {/* buttons */}
          <Col>
            <div style={{ display: "flex", marginLeft: -6 }}>
              <GoChevronLeft
                onClick={showLess}
                size={24}
                style={{
                  cursor:
                    type == "Departures" && departureSkip - limit < 0
                      ? null
                      : type == "Arrivals" && arrivalSkip - limit < 0
                        ? null
                        : "pointer",
                  opacity:
                    type == "Departures" && departureSkip - limit < 0
                      ? 0.3
                      : type == "Arrivals" && arrivalSkip - limit < 0
                        ? 0.3
                        : 1.0,
                  pointerEvents:
                    type == "Departures" && departureSkip - limit < 0
                      ? "none"
                      : type == "Arrivals" && arrivalSkip - limit < 0
                        ? "none"
                        : "auto",
                }}
                color={Colors.PRM_LIGHT_BLUE}
              />
              <GoChevronRight
                onClick={showMore}
                size={24}
                style={{
                  marginLeft: 28,
                  cursor:
                    type == "Departures" &&
                      departureSkip + limit > departuresCount
                      ? null
                      : type == "Arrivals" &&
                        arrivalSkip + limit > arrivalsCount
                        ? null
                        : "pointer",
                  opacity:
                    type == "Departures" &&
                      departureSkip + limit > departuresCount
                      ? 0.3
                      : type == "Arrivals" &&
                        arrivalSkip + limit > arrivalsCount
                        ? 0.3
                        : 1.0,
                  pointerEvents:
                    type == "Departures" &&
                      departureSkip + limit > departuresCount
                      ? "none"
                      : type == "Arrivals" &&
                        arrivalSkip + limit > arrivalsCount
                        ? "none"
                        : "auto",
                }}
                color={Colors.PRM_LIGHT_BLUE}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PaginationClicker;
